// Plantillas de preguntas propias de los permisos de trabajo (M7; `active`
// con M12, bloque 5c, §17 ítem 88).

/** La columna pedida no existe (p. ej. `active` antes de aplicar M12). */
export function esColumnaInexistente(error: { code?: string; message?: string } | null | undefined): boolean {
  if (!error) return false;
  return error.code === '42703' || error.code === 'PGRST204'
    || /column .* does not exist|could not find the .* column/i.test(error.message ?? '');
}

/** Error en español para el texto de una pregunta, o null si sirve. */
export function validarTextoPregunta(texto: string): string | null {
  const t = texto.trim();
  if (!t) return 'Escribe la pregunta.';
  if (t.length > 500) return 'La pregunta no puede pasar de 500 caracteres.';
  return null;
}

/** Mensaje en español para un error de Supabase al guardar una plantilla. */
export function mensajeErrorPlantilla(error: { code?: string; message?: string }): string {
  if (error.code === '23505') return 'Ya hay una pregunta guardada con ese mismo texto para este tipo de permiso.';
  if (error.code === '42501') return 'No tienes permiso para hacer este cambio.';
  return 'No se pudo guardar el cambio. Intenta de nuevo.';
}

/** Solo las activas se copian a los permisos nuevos. Sin M12 (`active` undefined) todas cuentan como activas. */
export function plantillasACopiar<T extends { active?: boolean | null }>(plantillas: T[]): T[] {
  return plantillas.filter(p => p.active !== false);
}
